import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import formValidation from './formValidation';
import { useDispatch } from 'react-redux';
import * as affiliateActions from '../../store/affiliates/actions';

const FormAffiliate = ({
  loading,
  affiliate,
  affiliates,
  create,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const editingAffiliate = affiliate || {};

  const [error, setError] = useState('');

  const initialValues = {
    name: editingAffiliate.name || '',
    code: editingAffiliate.code || '',
    monthlyCommission: editingAffiliate.monthlyCommission || '',
    semiannualCommission: editingAffiliate.semiannualCommission || '',
    isActive:
      editingAffiliate.isActive !== undefined
        ? editingAffiliate.isActive
        : true,
  };

  const handleSubmit = (values) => {
    const data = {
      ...values,
      monthlyCommission: parseFloat(values.monthlyCommission),
      semiannualCommission: parseFloat(values.semiannualCommission),
    };

    const isCodeAlreadyExists = affiliates.some(
      (affiliate) =>
        affiliate.code === values.code && affiliate.id !== editingAffiliate?.id,
    );
    if (isCodeAlreadyExists) {
      setError('Il codice affiliato è già esistente');
      return;
    }

    dispatch(
      create
        ? affiliateActions.createAffiliate(data)
        : affiliateActions.updateAffiliate({
            id: editingAffiliate.id,
            ...data,
          }),
    );
    closeModal();
  };

  return (
    <Card>
      <CardBody>
        {error && <Alert color="danger">{error}</Alert>}
        <Formik
          initialValues={initialValues}
          validationSchema={formValidation()}
          onSubmit={handleSubmit}
          enableReinitialize>
          {({ errors, touched, isValid }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="name">Nome Affiliato *</Label>
                    <Field
                      as={Input}
                      id="name"
                      name="name"
                      type="text"
                      invalid={touched.name && !!errors.name}
                    />
                    {touched.name && errors.name && (
                      <div className="invalid-feedback d-block">
                        {errors.name}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="code">Codice Affiliato *</Label>
                    <Field
                      as={Input}
                      id="code"
                      name="code"
                      type="text"
                      invalid={touched.code && !!errors.code}
                    />
                    {touched.code && errors.code && (
                      <div className="invalid-feedback d-block">
                        {errors.code}
                      </div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="monthlyCommission">
                      Commissione Piano Mensile (€) *
                    </Label>
                    <Field
                      as={Input}
                      id="monthlyCommission"
                      name="monthlyCommission"
                      type="number"
                      step="0.01"
                      min="0"
                      invalid={
                        touched.monthlyCommission && !!errors.monthlyCommission
                      }
                    />
                    {touched.monthlyCommission && errors.monthlyCommission && (
                      <div className="invalid-feedback d-block">
                        {errors.monthlyCommission}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="semiannualCommission">
                      Commissione Piano Semestrale (€) *
                    </Label>
                    <Field
                      as={Input}
                      id="semiannualCommission"
                      name="semiannualCommission"
                      type="number"
                      step="0.01"
                      min="0"
                      invalid={
                        touched.semiannualCommission &&
                        !!errors.semiannualCommission
                      }
                    />
                    {touched.semiannualCommission &&
                      errors.semiannualCommission && (
                        <div className="invalid-feedback d-block">
                          {errors.semiannualCommission}
                        </div>
                      )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup check>
                    <Label check for="isActive">
                      <Field
                        as={Input}
                        id="isActive"
                        name="isActive"
                        type="checkbox"
                      />
                      Affiliato attivo
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <div className="modal-footer">
                <Button
                  type="button"
                  color="secondary"
                  onClick={closeModal}
                  disabled={loading}>
                  Annulla
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={!isValid || loading}>
                  {loading ? (
                    <>
                      <i className="bx bx-loader-alt bx-spin mr-1" />{' '}
                      Salvataggio...
                    </>
                  ) : (
                    <>
                      <i className="bx bx-save mr-1" />{' '}
                      {create ? 'Crea Affiliato' : 'Salva Modifiche'}
                    </>
                  )}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </CardBody>
    </Card>
  );
};

export default FormAffiliate;
